import React from "react";
import "./PromoBanner.css"; // CSS file for styling
import productImageFromFile from "../assets/img/image 8.png"; // Renamed for clarity from the prop name
import { Link } from "react-router-dom";

// If your background image is also static, you could import it too:
// import bannerBgFromFile from "../assets/img/back-1.png";

const PromoBanner = () => {
  // Removed userProductsImage from props
  return (
    <section className="promo-banner">
      <h2 className="promo-heading">Elevate Every Puff</h2>
      <p className="promo-code-text">
        Crafted for those who live bold and breathe free.
      </p>
      <Link to="/category/67f040b28b7647368d057bdd">
        <button className="promo-shop-now-button">Explore Collection</button>
      </Link>
    </section>
  );
};

export default PromoBanner;
